// extracted by mini-css-extract-plugin
module.exports = {"fade_in_section":"FadeInSection_fade_in_section__3FwLp","is_visible":"FadeInSection_is_visible__275QF"};